import Panel from 'components/Panel'
import Slider from 'components/Slider'
import { ButtonLink } from 'components/Button'
import Slide from './Slide'

const DeviceSlider = ({
  devices,
  isFetching,
  setDevice,
  currentDevice,
  productNamePlural
}) => {
  const slides = devices.map((device) => (
    <div key={device.id}>
      <Slide
        device={device}
        handleClick={setDevice}
        selected={device === currentDevice}
      />
    </div>
  ))

  const manualsLink = (
    <ButtonLink to="/faqs?category=User Guides">Manuals</ButtonLink>
  )
  return (
    <Panel title={productNamePlural || 'Products'} buttons={manualsLink}>
      {!isFetching && <Slider>{slides}</Slider>}
    </Panel>
  )
}

export default DeviceSlider
